import axios from 'axios';
import config from '../config';

const baseUrl = config.baseUrl + '/api';

const getdesagregacion= async () => {
    try {
        const response = await axios.get(`${baseUrl}/desagregacion`);
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};

const getclasificacion = async (areaId) => {
    try {
        const response = await axios.get(`${baseUrl}/clasificacion`, {
            params: { areaTematicaId: areaId }, // Cambiado para enviar como parámetro de consulta
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo los temas del área', error);
        throw error;
    }
};

export {
    getdesagregacion,
    getclasificacion
};